/**
 * ProductDetailContainer
 * --
 */
import React from 'react';
// import ProductDetailPresenter from './ProductDetailPresenter';
import ProductDetail from 'routes/admin.routes/admin.products/ProductDetail';
import { useUserStack } from 'store';

const ProductDetailContainer = () => {
  /* ===== ROUTE ===== */
  const userInfo = useUserStack();
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      {userInfo && (
        <ProductDetail
          permission={userInfo.type}
          defaultShopId={userInfo.shop_information_id}
        />
      )}
    </>
  );
};

export default ProductDetailContainer;
